import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollReveal = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    const t = setTimeout(() => {
      document.querySelectorAll("main section, [data-testid] > section").forEach((s, i) => {
        if (i === 0 || s.closest("[data-testid=mega-menu]")) return;
        s.classList.add("reveal");
        io.observe(s);
      });
    }, 60);
    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, [pathname]);
  return null;
};
